import React, { createContext } from 'react'

export const FeatureBlueprintContext = createContext();